import React from 'react';

export const LinkSignUp: React.FC = () => {
  return (
    <a
      href={process.env.REACT_APP_LINK_SIGNUP}
      target="_blank"
      rel="noopener noreferrer"
      className="text-[13px] font-medium text-white/80 underline hover:text-white/90 cursor-pointer transition-colors text-center"
    >
      Not Registered? Sign Up Here
    </a>
  );
};